import { render, staticRenderFns } from "./intel_city.vue?vue&type=template&id=bf272682&scoped=true&"
import script from "./intel_city.vue?vue&type=script&lang=js&"
export * from "./intel_city.vue?vue&type=script&lang=js&"
import style0 from "./intel_city.vue?vue&type=style&index=0&id=bf272682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf272682",
  null
  
)

export default component.exports